import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { readOrgLocation } from './lib/orgContext';
import App from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('ไม่พบ element #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename={readOrgLocation().basename || undefined}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
